// Английские строки. Могут быть неполными — недостающие ключи падают обратно на ru.

import type { MessageKey } from './ru';

export const en: Partial<Record<MessageKey, string>> = {
  'app.name': 'Restomarker',
  'app.start.placeholder': 'Application shell. Screens arrive in tasks T-001…T-007.',
  'network.offline': 'No connection — working offline',
  'network.syncing': 'Syncing…',
  'network.queued': 'Queued',
};
